import { combineReducers } from 'redux';
import user from './userReducer';
import ui from './uiReducer';
import settings from './settingsReducer';
import workflow from './workflowReducer';
import jobs from './jobsReducer';
import presence from './presenceReducer';
import ai from './aiReducer';
import embedded from './embeddedReducer';
import turnkey from './turnkeyReducer';
import pubSub from './pubSubReducer';
import service from './serviceReducer';
import operations from './operationsReducer';
import monitoring from './monitoringReducer';

const rootReducer = (routerReducer) =>
  combineReducers({
    router: routerReducer,
    settings,
    user,
    ui,
    workflow,
    jobs,
    presence,
    ai,
    embedded,
    turnkey,
    pubSub,
    service,
    operations,
    monitoring
  });

export default rootReducer;
